"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const themed_1 = require("@rneui/themed");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const CustomHeader = () => {
    return (react_1.default.createElement(react_native_1.View, { style: styles.container },
        react_1.default.createElement(themed_1.Text, { style: styles.text }, "\u041A\u0438\u0440\u0438\u043B\u043B & \u0410\u043D\u044E\u0442\u0430"),
        react_1.default.createElement(themed_1.Text, { style: styles.textSecond }, "07.06.2022")));
};
exports.default = CustomHeader;
const styles = react_native_1.StyleSheet.create({
    container: {
        backgroundColor: 'rgba(52, 52, 52, 0.8)',
        alignSelf: 'center',
        paddingHorizontal: 20,
        paddingVertical: 10,
        borderRadius: 20,
        alignItems: 'center',
        borderWidth: 2,
    },
    text: {
        fontSize: 40,
        fontFamily: 'Cursive',
        color: 'white',
    },
    textSecond: {
        fontSize: 25,
        fontFamily: 'Cursive',
        color: 'white',
    },
});
